import axios from "../utils/axios";

export const getAllAcademicYears = async (page = 1, per_page = 15, filters = {}) => {
    const params = { ...filters };
    if (page) params.page = page;
    if (per_page) params.per_page = per_page;
    const { data } = await axios.get('/academic-years', { params });
    return data;
};

export const getAcademicYear = async (id) => {
    const { data } = await axios.get(`/academic-years/${id}`);
    return data;
};

export const createAcademicYear = async (req) => {
    const { data } = await axios.post('/academic-years', req, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const updateAcademicYear = async (req, id) => {
    const { data } = await axios.put(`/academic-years/${id}`, req, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const deleteAcademicYear = async (id) => {
    const { data } = await axios.delete(`/academic-years/${id}`, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const deleteAllAcademicYears = async (req) => {
    const { data } = await axios.delete('/academic-years/mass-destroy', {
        data: req,
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const forceDeleteAcademicYear = async (id) => {
    const { data } = await axios.delete(`/academic-years/${id}/force-delete`, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const forceDeleteAllAcademicYears = async (ids) => {
    const { data } = await axios.delete('/academic-years/mass-force-delete', {
        data: ids,
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const restoreAcademicYear = async (id) => {
    const { data } = await axios.post(`/academic-years/${id}/restore`, {}, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const restoreAllAcademicYears = async (req) => {
    const { data } = await axios.post('/academic-years/mass-restore', req, {
        headers: { Accept: 'application/json' },
    });
    return data;
};
